/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
import Vue from 'vue';
import Home from './Home';
import Profile from './Profile';
import ProfileForm from './ProfileForm';
import Subscribe from './Subscribe';
import Campaigns from './campaigns/Campaigns'
import NewCampaign from './campaigns/NewCampaign'
import PlansList from './plans/PlansList';
import Users from './users/Users';
import Settings from './Settings'
import SignUp from './SignUp'
import Billing from './Billing'
import Goals from './goals/Goals'
import Accounts from './admin/accounts/Accounts'
import AdminAccountUsers from './admin/accounts/AdminAccountUsers'
import AdminAccountDashboard from './admin/dashboard/AdminAccountDashboard'
import FacebookOauth from './FacebookOauth'
import Onboarding from './Onboarding'
import Dashboard from './Dashboard'
import Analytics from './Analytics'
import Tasks from './Tasks'

Vue.component('profile-form', ProfileForm)

export {
  Home,
  Campaigns,
  NewCampaign,
  Profile,
  ProfileForm,
  Subscribe,
  PlansList,
  Users,
  Settings,
  SignUp,
  Billing,
  Goals,
  Accounts,
  AdminAccountDashboard,
  AdminAccountUsers,
  FacebookOauth,
  Onboarding,
  Dashboard,
  Analytics,
  Tasks
}



// WEBPACK FOOTER //
// ./src/components/index.js